
import React, { memo, useState, useEffect } from 'react';
import { Position, useReactFlow } from '@xyflow/react';
import { NodeHandle } from '../common/NodeHandles';
import { Textarea } from '@/components/ui/textarea';

interface PositionNodeProps {
  data: {
    label: string;
    notes?: string;
  };
  id: string;
}

export const PositionNode = memo(({ data, id }: PositionNodeProps) => {
  const [notes, setNotes] = useState(data.notes || "");
  const { setNodes } = useReactFlow();
  
  const handleNotesChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newNotes = e.target.value;
    setNotes(newNotes);
    
    // Update the node data in the flow
    setNodes((nodes) => 
      nodes.map((node) => {
        if (node.id === id) {
          return {
            ...node,
            data: {
              ...node.data,
              notes: newNotes
            }
          };
        }
        return node;
      })
    );
  };

  // Calculate appropriate height based on content
  useEffect(() => {
    const textarea = document.getElementById(`position-notes-${id}`);
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    }
  }, [notes, id]);

  return (
    <div className="position-node bg-blue-50 shadow-md rounded-lg p-4 border-2 border-blue-300 min-w-[200px]">
      <NodeHandle type="target" position={Position.Top} nodeId={id} />
      <div className="text-center font-medium mb-2">Position</div>
      <Textarea 
        id={`position-notes-${id}`}
        value={notes} 
        onChange={handleNotesChange}
        className="text-xs resize-none bg-white/70 min-h-[80px] overflow-hidden"
        placeholder="Name your position. What do you need to remember here? Think posture, grips, or the goal from this position."
        style={{ overflow: 'hidden' }}
      />
      <NodeHandle type="source" position={Position.Bottom} nodeId={id} />
    </div>
  );
});
